import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { TypedMemo } from '../../../common/types';
import { commandPaletteMessages as messages } from './commandPaletteMessages';
import styles from './PaletteSeeAllRow.module.scss';

interface PaletteSeeAllRowProps {
  selected: boolean;
  onPick: () => void;
  onHover: () => void;
}

/** The last row: the full Search page with the same text, also on Shift+Enter (design 5d, 5e). */
const PaletteSeeAllRowComponent: React.FC<PaletteSeeAllRowProps> = ({ selected, onPick, onHover }) => {
  const intl = useIntl();
  return (
    <button
      type="button"
      className={clsx(styles.resultItem, styles.seeAll, selected && styles.resultItemSelected)}
      onClick={onPick}
      onMouseEnter={onHover}
      data-testid="palette-see-all"
    >
      <FontAwesomeIcon icon={faMagnifyingGlass} className={styles.seeAllIcon} />
      <div className={styles.resultText}>
        <div className={styles.resultTitle}>{intl.formatMessage(messages.seeAll)}</div>
      </div>
      <kbd className={styles.kbd}>⇧↵</kbd>
    </button>
  );
};

export const PaletteSeeAllRow = TypedMemo(PaletteSeeAllRowComponent);
